import { BRA_SIZE_COUNTRIES_ASIA } from './braSizeCalculationAsia';

export const isAsiaBraSizeCountry = country =>
  Boolean(country && BRA_SIZE_COUNTRIES_ASIA.includes(country.toLowerCase()));
